import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiDivider: MuiComponent<"MuiDivider"> = {
  styleOverrides: {
    root: {
      borderColor: Colors.BorderGray,
      margin: "0!important",
    },
  },
};